import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLTextAreaElement> {
  static targets = ["textarea", "fontsize"]

  declare readonly textareaTarget: HTMLTextAreaElement
  declare readonly fontsizeTarget: HTMLInputElement

  connect() {
    this.adjustFontSize()
    this.element.addEventListener("input", () => this.adjustFontSize())
  }

  adjustFontSize() {
    const MIN_FONT_SIZE = 1
    const SIZE_FACTOR = 0.9
    this.textareaTarget.style.fontSize = "2.5em"
    this.updateFontSizeAttribute()

    let currentFontSize = parseFloat(this.textareaTarget.style.fontSize)

    while (
      this.textareaTarget.scrollHeight > this.textareaTarget.clientHeight &&
      currentFontSize > MIN_FONT_SIZE
    ) {
      currentFontSize *= SIZE_FACTOR
      this.textareaTarget.style.fontSize = `${currentFontSize}em`
      this.updateFontSizeAttribute()
    }
  }

  updateFontSizeAttribute() {
    this.fontsizeTarget.value = this.textareaTarget.style.fontSize
  }
}
